/** 業界の公開：非公開 */
export const RFP_IS_OPEN_EXPERIENCED_INDUSTRY_CLASS_NAME_NG = {
    label: '非公開',
    value: 0,
};
/** 業界の公開：公開 */
export const RFP_IS_OPEN_EXPERIENCED_INDUSTRY_CLASS_NAME_OK = {
    label: '公開',
    value: 1,
};
/** 業界の公開一覧 */
export const RFP_IS_OPEN_EXPERIENCED_INDUSTRY_CLASS_NAMES = [
    RFP_IS_OPEN_EXPERIENCED_INDUSTRY_CLASS_NAME_NG,
    RFP_IS_OPEN_EXPERIENCED_INDUSTRY_CLASS_NAME_OK,
];
